



































import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { USER_NS } from '~/store/modules/shared/user/state'
export default Vue.extend({
  components: {
    SellerTags: () =>
      import('~/components/car/classifieds/view/partials/SellerTags')
  },
  props: {
    title: {
      type: String,
      default: null
    },
    titleParts: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      seller: state => state.seller,
      discount: state => state.classified.discount
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      isWanted: 'isWanted',
      isDamaged: 'isDamaged',
      isForRent: 'isForRent',
      isNew: 'isNew',
      isDealersOnly: 'isDealersOnly'
    }),
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin'
    })
  },
  mounted() {
    if (!this.title && !this.titleParts) {
      throw new Error('mounted: Title and TitleParts is null.')
    }
  }
})
